import { createReducer } from '@reduxjs/toolkit';

const initialState = {
  data: {},
};

export default createReducer(initialState, (builder) => {
  builder.addCase('GLOBAL_ERRORS_SET', (state, action: any) => {
    const { errors } = action.payload;

    state.data = {
      ...state.data,
      ...errors,
    };
  });
});
